import { useProps } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import { translate } from 'i18n/i18n'
import { useEffect, useState } from 'react'
import { DateRangePickerDropdown } from './DateRangePickerDropdown'
import type { DateRangePickerWithFooterProps, DatesRangeValue, dropdownType } from './types'

export const MANTINE_DATE_RANGE_PICKER_WIDTH = 240

export const MantineDateRangePickerWithFooter = (props: DateRangePickerWithFooterProps) => {
  const defaultProps = {
    valueFormat: translate.dates.getMomentFormat('MMMM D, YYYY'),
    closeOnChange: false,
    sortDates: true,
    dropdownType: 'popover' as dropdownType,
    allowSingleDateInRange: true,
  }

  const [originalValue, setOriginalValue] = useState<DatesRangeValue>([null, null])
  const [value, setValue] = useState<DatesRangeValue>(props.defaultValue || [null, null])
  const [dropDownOpened, setDropdownOpened] = useState(false)

  useEffect(() => {
    setOriginalValue(value)
  }, [dropDownOpened])

  useEffect(() => {
    setValue(props.defaultValue || [null, null])

    setOriginalValue(props.defaultValue || [null, null])
  }, [props.defaultValue])

  const dismiss = () => {
    setValue(originalValue)

    setDropdownOpened(false)
  }

  const {
    allowSingleDateInRange,
    closeOnChange,
    defaultValue,
    Footer,
    maxDate,
    minDate,
    placeholder,
    styles,
    sortDates,
    renderDayWithValue,
    valueFormat,
  } = useProps('DatePickerInput', defaultProps, props)

  return (
    <div css={{ height: 42, width: props.hasResponsiveWidth ? '100%' : MANTINE_DATE_RANGE_PICKER_WIDTH }}>
      <div css={{ position: props.hasResponsiveWidth ? 'relative' : 'absolute', zIndex: 100 }}>
        <DatePickerInput<'range'>
          clearable={false}
          closeOnChange={closeOnChange}
          defaultValue={defaultValue}
          leftSection={props.leftSection}
          leftSectionPointerEvents="none"
          placeholder={placeholder}
          sortDates={sortDates}
          classNames={props.classNames}
          styles={styles}
          type="range"
          valueFormat={valueFormat}
          onClick={() => setDropdownOpened((prev) => !prev)}
          value={value}
          popoverProps={{
            opened: false, // Using a custom component, so don't use the popover.
          }}
          css={{ width: props.hasResponsiveWidth ? '100%' : MANTINE_DATE_RANGE_PICKER_WIDTH }}
        />
        <DateRangePickerDropdown
          dismiss={dismiss}
          dropDownOpened={dropDownOpened}
          setDropdownOpened={setDropdownOpened}
          value={value}
          setValue={setValue}
          renderDayWithValue={renderDayWithValue}
          Footer={Footer}
          allowSingleDateInRange={allowSingleDateInRange}
          defaultValue={defaultValue}
          maxDate={maxDate}
          minDate={minDate}
          classNames={props.classNames}
          styles={props.styles}
        />
      </div>
    </div>
  )
}
